// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","461":"b637e9a5","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"75a52a50527985baae25","293":"53d7f7c28466b438806c","461":"31dcb7c3715106bb3cbe","518":"f585d87341a3d1997985","779":"4d90a4503482b239d4f8"}[chunkId] + ".js";
};